export default {
  mobileLanding: {
    media: {
      appPreview: "Aperçu animé de l'app",
      leagues: "Écran de sélection des ligues",
      trendFlow: "Flux animé des tendances",
      trendAnalysis: "Écran d'analyse détaillée des tendances",
      myPicks: "Écran Mes picks",
      checkout: "Écran de checkout",
    },
    sections: {
      research: {
        heading: "Passez de la recherche au pari en quelques secondes",
        body: "Linemate fait la recherche pour vous en analysant les tendances et les matchups, pour passer de l'information au pari sans passer des heures à fouiller.",
      },
      leagues: {
        body: "Choisissez parmi plus de 18 ligues majeures pour explorer des tendances et des jeux adaptés aux matchs et joueurs qui vous intéressent le plus.",
      },
      trends: {
        body: "Parcourez les tendances les plus performantes et choisissez un jeu appuyé par de vraies données, la forme récente et un contexte pertinent.",
      },
      analysis: {
        body: "Allez plus loin dans chaque jeu avec des analyses claires de la performance, du contexte situationnel et des signaux clés qui portent la tendance.",
      },
      odds: {
        body: "Trouvez les meilleures cotes disponibles chez les opérateurs et tirez le maximum de valeur de chaque pari.",
      },
      checkout: {
        body: "Passez au pari en quelques secondes avec votre betslip automatiquement rempli chez votre opérateur préféré.",
      },
    },
    cta: {
      titleLineOne: "Votre maison",
      titleLineTwo: "pour chaque pari",
    },
  },
};
